import { render, staticRenderFns } from "./EtapaFormulario.vue?vue&type=template&id=533d6863&"
import script from "./EtapaFormulario.vue?vue&type=script&lang=js&"
export * from "./EtapaFormulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports